<script lang="ts">
	import type { NotificationInstance } from '@svelte-put/noti';
	import { createEventDispatcher } from 'svelte';
	import { fly } from 'svelte/transition';

	// optional, injected automatically by @svelte-put/noti
	export let notification: NotificationInstance;

	export let content = 'Placeholder';
	export let special = false;

	const { progress } = notification;

	const dispatch = createEventDispatcher<{ resolve: string }>();
	const dismiss = () => dispatch('resolve', 'popped from within component');
</script>

<!-- eslint-disable svelte/valid-compile -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
	class="relative flex items-start justify-between px-4 py-5 bg-blue-200 shadow-lg pointer-events-auto rounded-t-xl not-prose text-dark md:items-center"
	class:bg-pink-300={special}
	in:fly|global={{ duration: 200, y: -20 }}
	on:mouseenter={progress.pause}
	on:mouseleave={progress.resume}
>
	<p>{content}</p>
	<button on:click={dismiss} class="md-max:mt-0.5 ml-3">
		<img class="w-full h-full" src={'/close.svg'} alt="close" />
	</button>
	<div
		class="progress absolute inset-x-0 bottom-0 h-0.5 bg-blue-500 origin-left"
		class:bg-pink-500={special}
		class:paused={$progress.state === 'paused'}
		style={`--progress-duration: ${notification.timeout}ms;`}
	/>
</div>

<style>
	.progress {
		animation: progress var(--progress-duration) linear;
	}

	.progress.paused {
		animation-play-state: paused;
	}

	@keyframes progress {
		from {
			transform: scaleX(0);
		}

		to {
			transform: scaleX(1);
		}
	}
</style>
